<template>
  <BasePagination v-bind="$attrs"
                  v-model="currentPage"
                  v-on="$listeners"
                  :alwaysShowStartPage="alwaysShowStartPage"
                  :alwaysShowEndPage="alwaysShowEndPage"
                  :buttonStyle="buttonStyle"
                  :disabled="disabled"
                  :ellipsisStyle="ellipsisStyle"
                  :numberStyle="numberStyle"
                  :sidePageSize="sidePageSize">
  </BasePagination>
</template>

<script>
  import BasePagination from '@base/base-pagination'
  import { FontStyle } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'PaginationPrimary',
    inheritAttrs: false,
    model: {
      prop: 'vmodelValue',
      event: 'click',
    },
    components: {
      BasePagination,
    },
    props: {
      vmodelValue: { type: Number },
      disabled: { type: Boolean, required: false, default: false },
    },
    data: function () {
      return {
        alwaysShowStartPage: true,
        alwaysShowEndPage: true,
        buttonStyle: {
          borderRadius: '4px',
          cursor: { '': 'pointer', disabled: 'default' },
          fontFamily: FontStyle.family.primary,
          fontSize: FontStyle.size.md,
          fontWeight: { '': FontStyle.weight.md, selected: FontStyle.weight.lg },
          height: '32px',
          margin: '0 4px',
          minWidth: '32px',
          userSelect: 'none',
          width: '32px',
        },
        currentPage: 1,
        ellipsisStyle: {
          cursor: 'default',
          fontFamily: FontStyle.family.primary,
          fontSize: FontStyle.size.md,
          fontWeight: FontStyle.weight.md,
          height: '32px',
          margin: '0 4px',
          minWidth: '32px',
          userSelect: 'none',
          width: '32px',
        },
        numberStyle: {
          borderRadius: '4px',
          cursor: { '': 'pointer', disabled: 'default' },
          fontFamily: FontStyle.family.primary,
          fontSize: FontStyle.size.md,
          fontWeight: { '': FontStyle.weight.md, selected: FontStyle.weight.lg },
          height: '32px',
          margin: '0 4px',
          minWidth: '32px',
          userSelect: 'none',
          width: '32px',
        },
        sidePageSize: 3,
      };
    },
    created: function () {
      this.currentPage = this.vmodelValue;

      this.buttonStyle = {
        ...this.buttonStyle,
          backgroundColor: {
            '': this.color.light1(),
            hover: this.color.dark6(),
            active: this.color.dark6(),
            selected: this.color.dark6(),
            disabled: this.color.light1(),
          },
          border: {
            '': `solid ${this.color.dark4()}`,
            disabled: `solid ${this.color.dark5()}`,
          },
          borderWidth: '1px',
          color: { '': this.color.dark2(), disabled: this.color.dark4() },
      };

      this.ellipsisStyle = {
        ...this.ellipsisStyle,
        color: this.color.dark2(),
      };

      this.numberStyle = {
        ...this.numberStyle,
        backgroundColor: {
          '': this.color.light1(),
          hover: this.color.dark6(),
          active: this.color.dark6(),
          selected: this.color.dark6(),
          disabled: this.color.light1(),
        },
        border: {
          '': `solid ${this.color.dark4()}`,
          disabled: `solid ${this.color.dark5()}`,
        },
        borderWidth: '1px',
        color: { '': this.color.dark2(), disabled: this.color.dark4() },
      };
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
    },
  };
</script>
